module.exports = __webpack_public_path__ + "static/media/RRC+-+JackjonPT+Website+-+iMac+Mockup+v2.2+no+shadow.6d5e112e.png";